import { Validators } from "@angular/forms";
import { timer, of } from "rxjs";
import { SupportService } from "../../support/support/support.service";
import { catchError, map, switchMap } from "rxjs/operators";
import * as moment from 'moment-timezone';
import { DATE_FORMAT } from "../constant";
var RequiredValidator = function (message) {
    return function (control) {
        var error = Validators.required(control);
        if (!error) {
            return null;
        }
        return {
            'required': {
                value: control.value,
                i18n: 'validator error.required',
                message: message,
                params: null,
            }
        };
    };
};
var ɵ0 = RequiredValidator;
var MinLengthValidator = function (minLength, message) {
    return function (control) {
        var error = Validators.minLength(minLength)(control);
        if (!error) {
            return null;
        }
        return {
            'minLength': {
                value: control.value,
                i18n: 'validator error.minLength',
                message: message,
                params: [minLength],
            }
        };
    };
};
var ɵ1 = MinLengthValidator;
var PatternValidator = function (pattern, message) {
    return function (control) {
        var error = Validators.pattern(pattern)(control);
        if (!error) {
            return null;
        }
        return {
            'pattern': {
                value: control.value,
                i18n: 'validator error.pattern',
                message: message,
                params: [pattern],
            }
        };
    };
};
var ɵ2 = PatternValidator;
var JSONValidator = function (message) {
    return function (control) {
        try {
            JSON.parse(control.value);
            return null;
        }
        catch (err) {
            return {
                'json': {
                    value: control.value,
                    i18n: 'validator error.json',
                    message: message,
                    params: [control.value],
                }
            };
        }
    };
};
var ɵ3 = JSONValidator;
var EmailValidator = function (message) {
    return function (control) {
        var error = Validators.email(control);
        if (!error) {
            return null;
        }
        return {
            'email': {
                value: control.value,
                i18n: 'validator error.email',
                message: message,
                params: null,
            }
        };
    };
};
var ɵ4 = EmailValidator;
var LteValidator = function (lt, message) {
    return function (control) {
        if (control.value <= lt) {
            return null;
        }
        return {
            'lte': {
                value: control.value,
                i18n: 'validator error.lte',
                message: message,
                params: [lt],
            }
        };
    };
};
var ɵ5 = LteValidator;
var GteValidator = function (gt, message) {
    return function (control) {
        if (control.value >= gt) {
            return null;
        }
        return {
            'gte': {
                value: control.value,
                i18n: 'validator error.gte',
                message: message,
                params: [gt],
            }
        };
    };
};
var ɵ6 = GteValidator;
var DateValidator = function (format, message) {
    if (format === void 0) { format = DATE_FORMAT; }
    return function (control) {
        if (moment(control.value, [format, 'YYYY-MM-DDTHH:mm:ss.SSSZ'], true).isValid()) {
            return null;
        }
        return {
            'date': {
                value: control.value,
                i18n: 'validator error.date',
                message: message,
                params: [control.value || '', format],
            }
        };
    };
};
var ɵ7 = DateValidator;
var OnlyASCIValidator = function (message) {
    return function (control) {
        //TODO Переосмыслить данную валидацию. Например ещё знак минус/тире нужен в mark для промокода
        return null;
        if (/^\w+$/.test(control.value)) {
            return null;
        }
        return {
            'onlyASCI': {
                value: control.value,
                i18n: 'validator error.only ascii chars',
                message: message,
                params: null,
            }
        };
    };
};
var ɵ8 = OnlyASCIValidator;
var AsyncFnValidator = function (fn, name, message) {
    return function (control) {
        if (!control.value) {
            return of(null);
        }
        return timer(2000).pipe(switchMap(function () { return fn(control.value).pipe(map(function (err) {
            var _a;
            if (err) {
                var errors = (_a = {},
                    _a[name] = {
                        value: control.value,
                        i18n: err instanceof Error ? err.message : err.toString(),
                        message: message,
                        params: null,
                    },
                    _a);
                control.setErrors(errors);
                return errors;
            }
            control.setErrors(null);
            return null;
        })); }));
    };
};
var ɵ9 = AsyncFnValidator;
var FormControlASyncValidators = /** @class */ (function () {
    function FormControlASyncValidators(supportService) {
        this.supportService = supportService;
    }
    FormControlASyncValidators.prototype.emailExists = function (message) {
        var _this = this;
        return function (control) {
            return timer(2000).pipe(switchMap(function () { return _this.supportService.searchByEmail(control.value).pipe(map(function (data) {
                if (data) {
                    // Это нужно для того, чтобы директива formErrorIndicator
                    // отловила событие statusChanges и убрала спиннер
                    control.setErrors(null);
                    return null;
                }
                return {
                    'emailExists': {
                        value: control.value,
                        i18n: 'validator error.email is not found',
                        message: message,
                        params: null,
                    }
                };
            }), catchError(function () {
                return of({
                    emailExists: {
                        value: control.value,
                        i18n: 'validator error.email is not found',
                        message: message,
                        params: null,
                    }
                });
            })); }));
        };
    };
    FormControlASyncValidators.prototype.asyncFn = function (fn, name, message) {
        return function (control) {
            if (!control.value) {
                return of(null);
            }
            return timer(2000).pipe(switchMap(function () { return fn(control.value).pipe(map(function (err) {
                var _a;
                if (err) {
                    var errors = (_a = {},
                        _a[name] = {
                            value: control.value,
                            i18n: err instanceof Error ? err.message : err.toString(),
                            message: message,
                            params: null,
                        },
                        _a);
                    control.setErrors(errors);
                    return errors;
                }
                control.setErrors(null);
                return null;
            })); }));
        };
    };
    return FormControlASyncValidators;
}());
export { FormControlASyncValidators };
var FormControlValidators = /** @class */ (function () {
    function FormControlValidators() {
    }
    FormControlValidators.required = function (message) {
        return RequiredValidator(message);
    };
    FormControlValidators.minLength = function (minLength, message) {
        return MinLengthValidator(minLength, message);
    };
    FormControlValidators.pattern = function (pattern, message) {
        return PatternValidator(pattern, message);
    };
    FormControlValidators.json = function (message) {
        return JSONValidator(message);
    };
    FormControlValidators.email = function (message) {
        return EmailValidator(message);
    };
    FormControlValidators.lte = function (lt, message) {
        return LteValidator(lt, message);
    };
    FormControlValidators.date = function (format, message) {
        if (format === void 0) { format = DATE_FORMAT; }
        return DateValidator(format, message);
    };
    FormControlValidators.gte = function (lt, message) {
        return GteValidator(lt, message);
    };
    FormControlValidators.onlyASCII = function (message) {
        return OnlyASCIValidator(message);
    };
    FormControlValidators.asyncFn = function (fn, name, message) {
        return AsyncFnValidator(fn, name, message);
    };
    return FormControlValidators;
}());
export { FormControlValidators };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9 };
